import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function historyList(data) {
  return request({
    url: URL.act.reconciliation.historyList,
    method: 'post',
    data
  })
}

export function queryByreconciliationHistoryUuid(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.act.reconciliation.queryByreconciliationHistoryUuid,
    method: 'post',
    data
  })
}
